<app-notification-view *ngIf="data && data.Status != 'Draft'" [data]="data"></app-notification-view>
<app-notification-edit *ngIf="data && data.Status == 'Draft'" [data]="data"></app-notification-edit>

<div class="wrapper-md" *ngIf="error">
    <app-breadcrumbs [items]="[{ url: '/notifications', text: 'notification_listTitle' }]"></app-breadcrumbs>
    <app-alert level="danger" *ngIf="error">{{error}}</app-alert>
</div>
